import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-steel py-5 sm:py-8" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-18" data-mp="pjg5q15wl80x">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-19" data-mp="avd0itzoq0d6">
          5 premium bonuses <span className="text-electric" data-id="element-20" data-mp="ftmtcxxxsovm">included</span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-3xl text-center text-sm font-medium leading-snug text-muted sm:text-base" data-id="element-21" data-mp="frtljfbl7ym1">
          You'll also receive 5 premium bonuses designed to help you check, test,
          troubleshoot, document, and diagnose appliance faults more efficiently.
        </p>

        <div className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-22" data-mp="3o3pum5spe6z1">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`rounded-lg border-2 border-navy bg-white p-3.5 sm:p-4 ${i === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-23" data-mp="3t2soqv75ass8" data-mpi={i}>
              <p className="w-fit rounded bg-electric px-2 py-0.5 font-display text-xs font-extrabold uppercase tracking-widest text-white" data-id="element-24" data-mp="3idwofjt8hcl8">
                {bonus.label}
              </p>
              <h3 className="mt-1.5 text-[15px] leading-tight text-navy sm:text-lg" data-id="element-25" data-mp="3r6i7l10s1lal">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-26" data-mp="3n67s8xr3hij2">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}